import { render, staticRenderFns } from "./link-list.vue?vue&type=template&id=2da8c588&scoped=true"
import script from "./link-list.vue?vue&type=script&lang=js"
export * from "./link-list.vue?vue&type=script&lang=js"
import style0 from "./link-list.vue?vue&type=style&index=0&id=2da8c588&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2da8c588",
  null
  
)

export default component.exports